import { createOssAssetsUrl } from '@/utils/createOssAssetsUrl';

export const IMAGE_GLOBAL_LOADING = createOssAssetsUrl(
  '/assets/img/cms-web/globalLoading.gif',
);
